// Write your JS code here
import './index.css'

const NotFound = () => (
  <div className="route-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/not-found-blog-img.png"
      alt="not found"
      className="route-image"
    />
    <h1 className="route-heading">Not Found</h1>
  </div>
)

export default NotFound
